/* tslint:disable */
/* eslint-disable */
/* @relayHash e7dc12bb90156d85f77df4a4f9d19b8a */

import { ConcreteRequest } from "relay-runtime";
export type FirmInteriorPortfolioMutationInput = {
    firmId: string;
    portfolioId: string;
    clientMutationId?: string | null;
};
export type firmPortfolioMutationVariables = {
    input: FirmInteriorPortfolioMutationInput;
};
export type firmPortfolioMutationResponse = {
    readonly firmInteriorPortfolioMutation: {
        readonly tradeFirm: {
            readonly serviceId: string | null;
        } | null;
    } | null;
};
export type firmPortfolioMutation = {
    readonly response: firmPortfolioMutationResponse;
    readonly variables: firmPortfolioMutationVariables;
};



const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "serviceId",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "firmPortfolioMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "FirmInteriorPortfolioMutationPayload",
        "kind": "LinkedField",
        "name": "firmInteriorPortfolioMutation",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "TradeFirmType",
            "kind": "LinkedField",
            "name": "tradeFirm",
            "plural": false,
            "selections": [
              (v2/*: any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Mutations",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "firmPortfolioMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "FirmInteriorPortfolioMutationPayload",
        "kind": "LinkedField",
        "name": "firmInteriorPortfolioMutation",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "TradeFirmType",
            "kind": "LinkedField",
            "name": "tradeFirm",
            "plural": false,
            "selections": [
              (v2/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "id",
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "id": "app-buyer-trade/306.0.0-2021-03-15T23:43:35.521Z/firmPortfolioMutation",
    "metadata": {},
    "name": "firmPortfolioMutation",
    "operationKind": "mutation",
    "text": null
  }
};
})();
(node as any).hash = 'a71adfc880f10c041efe19003110a145';
export default node;
